import React from "react";
import { Box } from "@mui/material";
import { IPreferences } from "@/logic/api";
import { PickupLocationManagementSettings } from "@/components/pickupLocation/PickupLocationManagementSettings";
import { ShuttlePickupRuleOptions } from "./ShuttlePickupRuleOptions";

interface ShuttlePickupManagementCardProps {
    onSave: (data: Partial<IPreferences>) => Promise<boolean>;
    showFields: boolean;
    showPickupLocationManagement: boolean;
    useLegacyFieldOptionsLayout?: boolean;
}

export const ShuttlePickupManagementCard: React.FC<ShuttlePickupManagementCardProps> = ({
    onSave,
    showFields,
    showPickupLocationManagement,
    useLegacyFieldOptionsLayout = false
}) => {
    return (
        <Box data-testid="shuttle-pickup-management-card">
            {showFields && (
                <ShuttlePickupRuleOptions
                    onSave={onSave}
                    useLegacyLayout={useLegacyFieldOptionsLayout}
                />
            )}
            {showPickupLocationManagement && <PickupLocationManagementSettings />}
        </Box>
    );
};
